export default __webpack_public_path__ + "img/homepage-interactive-cover.asset.1db97a86.jpg";